export default __webpack_public_path__ + "static/media/2223 knife block A top.29024377.png";